import { Textarea, type TextareaProps } from '@mantine/core'
import { type FC } from 'react'

export interface TextareaInputProps extends TextareaProps {}

export const TextareaInput: FC<TextareaInputProps> = (props) => (
  <Textarea
    autosize
    mb='xs'
    minRows={3}
    maxRows={6}
    radius='md'
    {...props}
  />
)
